import { get } from './api';

export const getCountries = () => get('COUNTRIES', 'api', '/referencedata/v2/countries');

export const getMunicipalities = () =>
  get('MUNICIPALITIES', 'api', '/digital-advice/v2/tax/calculation/kommuner');
